
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import EnviarImagem from "../componentes/EnviarImagem";
import { cpfMask } from "../services/funcoesAuxiliares";
import InputMask from "react-input-mask";
import { criarCarteiras, uploadImage, apiUrl } from "../services/requests";

const CriarCarteiraVendedor = () => {
  const { token } = useParams();

  const AnoMes = moment().format("YYMM");
  var random2 = "",
    d = 0;
  while (d < 3) {
    random2 += Math.floor(Math.random() * 10);
    d++;
  }
  var random1 = "",
    c = 0;
  while (c < 3) {
    random1 += Math.floor(Math.random() * 10);
    c++;
  }
  const codUso = `${AnoMes}-${random1}.${random2}`;

  const [nome, setNome] = useState("");
  const [instituicaoEnsino, setInstituicaoEnsino] = useState("");
  const [curso, setCurso] = useState("");
  const [imagemInicial] = useState(`${apiUrl}/images/0.png`);
  const [cpf, setCpf] = useState("");
  const [rg, setRg] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [imagem, setImagem] = useState("");
  const [error, setError] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [tokenVendedor, setTokenVendedor] = useState(null);


  useEffect(() => {
    if (token) {
      try {
        setTokenVendedor(token)
      } catch (error) {
        console.error("Token inválido:", error);
        toast.error("Token inválido ou expirado.");
      }
    }
  }, [token]);

  const cpfValidator = {
    isValid(cpf) {
      cpf = cpf.replace(/[^\d]+/g, '');
      if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

      let sum = 0;
      for (let i = 0; i < 9; i++) {
        sum += parseInt(cpf.charAt(i)) * (10 - i);
      }
      let remainder = (sum * 10) % 11;
      if (remainder === 10 || remainder === 11) remainder = 0;
      if (remainder !== parseInt(cpf.charAt(9))) return false;

      sum = 0;
      for (let i = 0; i < 10; i++) {
        sum += parseInt(cpf.charAt(i)) * (11 - i);
      }
      remainder = (sum * 10) % 11;
      if (remainder === 10 || remainder === 11) remainder = 0;
      if (remainder !== parseInt(cpf.charAt(10))) return false;

      return true;
    }
  };

  const criarCarteira = async (event) => {
    event.preventDefault();

    if (isButtonDisabled || isSubmitting) return;
    if (!cpfValidator.isValid(cpf)) {
      toast.error("CPF inválido!");
      return;
    }
    setIsSubmitting(true);

    try {
      if (imagem) {
        const formData = new FormData();
        formData.append("image", imagem);
        await uploadImage("/upload-image", formData);
      }

      await criarCarteiras(`/carteiras/vendedor?token=${tokenVendedor}`, {
        foto: imagem ? `${apiUrl}/images/${imagem.name}` : imagemInicial,
        codigoUso: codUso,
        nome,
        instituicaoEnsino,
        curso,
        cpf,
        rg,
        dataNascimento,
        email,
        telefone,
        observacao: "CARTEIRA DE VENDEDOR",
      });

      setError(false);
      toast.success("Carteira Criada Com Sucesso!");
    } catch (error) {
      if (error.request?.status === 409) {
        setError(true);
        console.log(error)
        toast.error(error.response?.data?.message);
      } else {
        toast.error("Erro ao criar carteira.");
      }
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const formData = [nome, instituicaoEnsino, curso, cpf, dataNascimento];
    const isValidFormData = formData.every((value) => value !== "");
    setIsButtonDisabled(!isValidFormData);
  }, [nome, instituicaoEnsino, curso, cpf, dataNascimento]);


  return (
    <>
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4 py-6">
      <div className="w-full max-w-4xl p-4 sm:p-6 lg:p-8 space-y-6 sm:space-y-8 bg-white rounded-lg shadow-md">
        <h1 className="text-xl sm:text-2xl font-bold text-center text-gray-800">Criar Carteira de Colaborador</h1>
        <div className="flex flex-col lg:flex-row items-center lg:items-start space-y-6 lg:space-y-0 lg:space-x-8">
          <div className="w-full lg:w-1/3">
            <EnviarImagem img={imagem} setImg={setImagem} />
          </div>
          <div className="w-full lg:w-2/3 space-y-4">
            <input
              value={nome}
              id="nome"
              type="text"
              placeholder="NOME"
              onChange={(e) => setNome(e.target.value.toUpperCase())}
              className="w-full p-3 border rounded-lg text-sm sm:text-base"
            />
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <input
                id="InstEnsino"
                placeholder="INSTITUIÇÃO DE ENSINO"
                value={instituicaoEnsino}
                type="text"
                onChange={(e) => setInstituicaoEnsino(e.target.value.toUpperCase())}
                className="w-full sm:w-1/2 p-3 border rounded-lg text-sm sm:text-base"
              />
              <input
                id="Curso"
                placeholder="CURSO"
                value={curso}
                type="text"
                onChange={(e) => setCurso(e.target.value.toUpperCase())}
                className="w-full sm:w-1/2 p-3 border rounded-lg text-sm sm:text-base"
              />
            </div>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <input
                id="cpf"
                placeholder="CPF"
                value={cpf}
                type="text"
                onChange={(e) => setCpf(cpfMask(e.target.value))}
                className="w-full sm:w-1/2 p-3 border rounded-lg text-sm sm:text-base"
              />
              <input
                id="RG"
                placeholder="RG"
                type="text"
                value={rg}
                onChange={(e) => setRg(e.target.value)}
                className="w-full sm:w-1/2 p-3 border rounded-lg text-sm sm:text-base"
              />
            </div>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <InputMask
                mask="99/99/9999"
                id="DataNascimento"
                placeholder="DATA DE NASCIMENTO"
                type="text"
                value={dataNascimento}
                onChange={(e) => setDataNascimento(e.target.value)}
                className="w-full sm:w-1/2 p-3 border rounded-lg text-sm sm:text-base"
              />
              <input
                id="telefone"
                placeholder="TELEFONE"
                type="text"
                value={telefone}
                onChange={(e) => setTelefone(e.target.value)}
                className="w-full sm:w-1/2 p-3 border rounded-lg text-sm sm:text-base"
              />
            </div>
            <input
              id="email"
              placeholder="EMAIL"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-3 border rounded-lg text-sm sm:text-base"
            />
            <div className="flex justify-center sm:justify-end">
              <button
                type="submit"
                className="w-full sm:w-auto px-6 py-3 text-white bg-blue-700 rounded-lg hover:bg-blue-800 disabled:opacity-50 text-sm sm:text-base"
                disabled={isButtonDisabled || isSubmitting}
                onClick={(event) => criarCarteira(event)}
              >
                {isSubmitting ? "CRIANDO..." : "CRIAR CARTEIRA"}
              </button>
            </div>
            {error && <p className="text-red-500 text-center text-sm sm:text-base">CPF já cadastrado!</p>}
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default CriarCarteiraVendedor;
